import { RouteRecordRaw } from 'vue-router'

import { accountRoutes } from '@/modules/account/routes/AccountRoutes'
import { betaFeatureRoutes } from '@/modules/betaFeatures/routes/BetaFeatureRoutes'
import { CSDateRoutes } from '@/modules/csDate/routes/CSDateRoutes'
import { floorPlanRoutes } from '@/modules/floorplan/routes/FloorPlanRoutes'
import { marketingRoutes } from '@/modules/mailchimp/routes/MarketingRoutes'
import { performanceRoutes } from '@/modules/performance/routes/PerformanceRoutes'
import { reportRoutes } from '@/modules/report/routes/ReportRoutes'
import { residencyRoutes } from '@/modules/residency/routes/ResidencyRoutes'
import { settingRoutes } from '@/modules/setting/routes/SettingRoutes'
import { showRoutes } from '@/modules/show/routes/ShowRoutes'
import { showTimeRoutes } from '@/modules/showtime/routes/ShowTimeRoutes'
import { venueUiRoutes } from '@/modules/venueUi/routes/VenueUiRoutes'

export const venueRoutes: RouteRecordRaw[] = [
  ...floorPlanRoutes,
  ...showTimeRoutes,
  ...showRoutes,
  ...performanceRoutes,
  ...reportRoutes,
  ...settingRoutes,
  ...residencyRoutes,
  ...accountRoutes,
  ...venueUiRoutes,
  ...betaFeatureRoutes,
  ...marketingRoutes,
  ...CSDateRoutes,
]
